import React from 'react';
import './RehashPossibleModal.scss';
import { modalOverlayBackgroundColor } from 'util/constants';
import GenericModal from 'components/GenericModal';
import { SelectedAccessory } from '@upstart/harmony/lib/legos/accessoryTypes';
import { AddOn } from '@upstart/harmony/lib/legos/pencilTypes';
import { Bundle, SelectedProduct } from '@upstart/harmony/lib/legos/penTypes';
import OfferOptionsRow from './OfferOptionsRow';

export interface RehashOffer {
  monthlyPayment: number;
  apr: number;
  contractMonths: number;
  downPayment: number;
  accessoriesAndProducts: {
    selectedAccessories?: SelectedAccessory[] | null;
    selectedAddOns?: Omit<AddOn, 'tekionEntity' | 'originIdentifier'>[];
    selectedBundles?: Omit<Bundle, 'highlightedText' | 'excludedProductIds'>[];
    selectedProducts?: Omit<SelectedProduct, 'tekionEntity' | 'source'>[];
    protectionPlanProductPriceOverrides?: {
      [key: string]: number;
    };
  };
}

interface RehashPossibleModalProps {
  isOpen: boolean;
  originalOffer: RehashOffer;
  rehashedOffer: RehashOffer;
  saveSelection: (selectedOffer: RehashOfferSelection) => void;
}

export type RehashOfferSelection = 'original' | 'rehashed';

const RehashPossibleModal: React.FC<RehashPossibleModalProps> = ({
  isOpen,
  originalOffer,
  rehashedOffer,
  saveSelection,
}) => {
  const [selectedOffer, setSelectedOffer] = React.useState<
    RehashOfferSelection
  >('rehashed');

  const customStyles = {
    overlay: {
      backgroundColor: modalOverlayBackgroundColor,
    },
  };

  return (
    <GenericModal
      isOpen={isOpen}
      contentLabel="Rehash Possible Modal"
      style={customStyles}
      title="Deal structure has been updated by the customer"
      actions={{
        primary: {
          label:
            selectedOffer === 'original'
              ? 'Continue with Original offer'
              : 'Continue with Updated offer',
          onClick: () => saveSelection(selectedOffer),
        },
      }}
    >
      <div className="offers-explanation">
        A new offer has been automatically generated to match the new deal
        structure.
      </div>

      <OfferOptionsRow
        originalOffer={originalOffer}
        rehashedOffer={rehashedOffer}
        selectedOffer={selectedOffer}
        setSelectedOffer={(offer: RehashOfferSelection) =>
          setSelectedOffer(offer)
        }
      />
    </GenericModal>
  );
};

export default RehashPossibleModal;
